import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://dibs-it-90174.firebaseio.com/'
});


export default instance;



// WEBPACK FOOTER //
// ./src/axios-drops.js